export default function storage() {
    return next => action => {
        const { name, value } = action && action.meta && action.meta.localStorage || {}
        if (name && value) localStorage.setItem(name, JSON.stringify(value))
        return next(action)
    }
}



// WEBPACK FOOTER //
// ./state/middlewares/local_storage.js